module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/sola_landscape-7259353c1f712e2952c17981552f69a6.png";